<template>
  <v-list-group v-model="showing"
                :append-icon="appendIcon">
    <v-subheader slot="activator">{{subheaderText}}</v-subheader>

    <slot/>

  </v-list-group>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'VListGroupSubheaderActivator',
  props: {
    subheaderText: {
      type: String,
      required: true,
    },
    toggleOpenIcon: {
      type: String,
      default: null,
    },
    toggleCloseIcon: {
      type: String,
      default: null,
    },
    open: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    appendIcon() {
      return this.showing ? this.toggleCloseIcon : this.toggleOpenIcon;
    },
  },
  data: () => ({
    showing: null,
  }),
  created() {
    if (open !== null) {
      this.showing = open;
    }

    this.toggleOpenIcon = this.toggleOpenIcon || this.$vuetify.icons.expand;
    this.toggleCloseIcon = this.toggleCloseIcon || this.$vuetify.icons.close;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/lists/ListGroupSubheaderActivator.vue